export const UnsupportedNetwork = () => {
  return <h1 className="flex justify-center">UnsupportedNetwork</h1>;
};
